import { render } from "./Equipment_add_button.vue?vue&type=template&id=1afbc433&scoped=true"
import script from "./Equipment_add_button.vue?vue&type=script&lang=js"
export * from "./Equipment_add_button.vue?vue&type=script&lang=js"

import "./Equipment_add_button.vue?vue&type=style&index=0&id=1afbc433&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afbc433"]])

export default __exports__